import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-block-start: -${primitive.$spacing7};

  ${Styles.desktop} {
    flex-direction: row;
    padding: 0;
    align-items: stretch;
    padding-block-start: 250px;
    margin-block-start: ${primitive.$spacing9};
    overflow: visible;
  }
`;
